export default class AppAlertProps {
	Severity?: "error" | "success" | "info" | "warning";
	Message: string = "";
	Open: boolean = false;

	public constructor(init?: Partial<AppAlertProps>) {
		Object.assign(this, init);
	}
}